import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import about from '../views/AboutView.vue'
import categoriesIndex from '../views/categoriesIndex.vue'
import categoriesView from '../views/categoriesView.vue'
import albumsIndex from '../views/albumsIndex.vue'
import albumsView from '../views/albumsView.vue'
import product from '../views/productsView.vue'
import news from '../views/newsIndex.vue'
import newsView from '../views/newsView.vue'
import contact from '../views/contact.vue'
Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'home',
		component: HomeView,
		meta: {
			i18nTranslate: 'home'
		}
	},
	{
		path: '/about',
		name: 'about',
		component: about,
		meta: {
			i18nTranslate: 'about'
		}
	},
	{
		path: '/categories',
		name: 'categories',
		component: categoriesIndex,
		meta: {
			i18nTranslate: 'categories'
		}
	},
	{
		path: '/categories/:slug',
		name: 'categories-view',
		component: categoriesView,
		meta: {
			i18nTranslate: 'categories'
		}
	},
	{
		path: '/categories/:categorySlug/products/:productSlug',
		name: 'product-view',
		component: product,
		meta: {
			i18nTranslate: 'categories'
		}
	},
	{
		path: '/albums',
		name: 'albums',
		component: albumsIndex,
		meta: {
			i18nTranslate: 'albums'
		}
	},
	{
		path: '/albums/:id',
		name: 'albums-view',
		component: albumsView,
		meta: {
			i18nTranslate: 'albums'
		}
	},
	{
		path: '/news',
		name: 'news',
		component: news,
		meta: {
			i18nTranslate: 'news'
		}
	},
	{
		path: '/news/:slug',
		name: 'news-view',
		component: newsView,
		meta: {
			i18nTranslate: 'news'
		}
	},
	{
		path: '/contact-us',
		name: 'contact',
		component: contact,
		meta: {
			i18nTranslate: 'contact'
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})

export default router
